import { cn } from "@theprelude/core";

export const FileUploadIcon: React.FC<
  React.ComponentPropsWithoutRef<"svg">
> = ({ className, ...props }) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 2.66536H3.33333V13.332H12.6667V5.33203H10V2.66536ZM2 1.99323C2 1.62806 2.29833 1.33203 2.66567 1.33203H10.6667L13.9998 4.66536L14 13.9937C14 14.3646 13.7034 14.6654 13.3377 14.6654H2.66227C2.29651 14.6654 2 14.3618 2 14.0042V1.99323ZM8.66667 7.9987V10.6654H7.33333V7.9987H5.33333L8 5.33203L10.6667 7.9987H8.66667Z" />
  </svg>
);
